<template>
  <div class="themeBody" :data-theme="themeMode">
      <div class="mainBoxForm" :class="{ 'mainBoxFormHigher': errorMsg }">

      <div class="centerBox">
        <go-back-button :back-url="'/account/userCenter'">
          <template v-slot:body>
            <div class="goBackButtonBody">
              <el-image
                  class="qidiLogo"
                  :src="require('@/assets/logo.png')"
                  :fit=" 'cover' "></el-image>
              <div class="cardBoxTitle">{{ $t('h.userCenter.changePassword') }}</div>
            </div>
          </template>
        </go-back-button>

        <div class="changePasswordFormBox">
          <el-form :model="ruleForm" ref="ruleForm" :rules="rule">
            <div class="empty-height" style="height: 100px"></div>

            <el-form-item prop="password">
              <el-input v-model="ruleForm.password" :placeholder="$t('h.common.password')+'*'" autocomplete="off"
                        :type="showPassword ? 'text' : 'password'">
                <i slot="suffix" @click="switchPassword">
                  <img
                      v-if="showPassword"
                      class="input_icon"
                      :src="require('@/assets/icons/password_show.png')"
                  />
                  <img
                      v-else
                      class="input_icon"
                      :src="require('@/assets/icons/password_hide.png')"
                  />
                </i>
              </el-input>
            </el-form-item>

            <el-form-item prop="newPassword">
              <el-input v-model="ruleForm.newPassword" :placeholder="$t('h.changePassword.newPassword')+'*'" autocomplete="off"
                        :type="showNewPassword ? 'text' : 'password'">
                <i slot="suffix" @click="switchNewPassword">
                  <img
                      v-if="showNewPassword"
                      class="input_icon"
                      :src="require('@/assets/icons/password_show.png')"
                  />
                  <img
                      v-else
                      class="input_icon"
                      :src="require('@/assets/icons/password_hide.png')"
                  />
                </i>
              </el-input>
            </el-form-item>

            <el-form-item prop="checkNewPassword">
              <el-input v-model="ruleForm.checkNewPassword" :placeholder="$t('h.forgetPassword.confirmPassword')+'*'" autocomplete="off"
                        :type="showcheckNewPassword ? 'text' : 'password'">
                <i slot="suffix" @click="switchcheckNewPassword">
                  <img
                      v-if="showcheckNewPassword"
                      class="input_icon"
                      :src="require('@/assets/icons/password_show.png')"
                  />
                  <img
                      v-else
                      class="input_icon"
                      :src="require('@/assets/icons/password_hide.png')"
                  />
                </i>
              </el-input>
            </el-form-item>

            <error-msg :errorMsg="errorMsg"/>

            <el-form-item style="margin-top: 20px">
              <el-button type="primary" class="subBtn" @click="submitForm('ruleForm')">{{$t('h.userCenter.change')}}
              </el-button>
            </el-form-item>

          </el-form>


<!--          <area-select-footer v-show="$store.state.isInSlicer==false"/>-->
<!--          <copyright style="margin-top: 80px" v-if="$store.state.isInSlicer==true"/>-->
<!--          <copyright v-else="$store.state.isInSlicer==false"/>-->

        </div>


      </div>

      <div class="pageFooter">
        <area-select-footer v-show="$store.state.isInSlicer==false"/>
        <copyright/>
      </div>

    </div>
  </div>
</template>

<script>
import {changePassword} from "@/api/api"
import {translateResMessage} from "~/utils/translateResMessage";

export default {
  data() {
    // 再次确认密码验证
    var validateCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('h.common.confirmPasswordInputLabel')));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error(this.$t('h.common.passwordMismatchErrorLabel')));
      } else {
        callback();
      }
    }
    return {
      errorMsg: '',//错误提示信息
      showPassword: false,// 是否显示当前密码
      showNewPassword: false,// 是否显示新密码
      showcheckNewPassword: false,// 是否显示确认新密码
      ruleForm: {
        password: '',
        newPassword: '',
        checkNewPassword: '',
      },
      rule: {
        password: [
          {required: true, message: this.$t('h.common.passwordInputLabel'), trigger: 'blur'},
          {min: 6, max: 20, message: this.$t('h.common.passwordInputLengthErrorLabel'), trigger: ['blur', 'change']},
        ],
        newPassword: [
          {required: true, message: this.$t('h.common.passwordInputLengthErrorLabel'), trigger: 'blur'},
          {min: 6, max: 20, message: this.$t('h.common.passwordInputLengthErrorLabel'), trigger: ['blur', 'change']},
        ],
        checkNewPassword: [
          {required: true, message: this.$t('h.common.checkPasswordInputLabel'), trigger: 'blur'},
          {validator: validateCheckPass, trigger: 'blur'}
        ],
      }
    }
  },
  computed: {
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    },
  },
  created() {
    if (localStorage.getItem("token") === "") {
      //this.$notify.error({
      //   title: this.$t('h.common.tip'),
      //   message: this.$t('h.common.tipNeedLogin'),
      // })
      this.$router.push("/account/login")
    } else {
      console.log('已经登录');
    }
  },
  methods: {
    //密码切换显示
    switchPassword() {
      this.showPassword = !this.showPassword;
    },
    switchNewPassword() {
      this.showNewPassword = !this.showNewPassword;
    },
    switchcheckNewPassword() {
      this.showcheckNewPassword = !this.showcheckNewPassword;
    },
    submitForm(formName) {
      this.errorMsg = ""
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = new FormData();
          formData.append('password', this.ruleForm.password);
          formData.append('new_password', this.ruleForm.newPassword);
          changePassword(formData).then(res => {
            console.log("res", res)
            if (res.status === 0) {
              //修改密码成功,为您跳转到登录页面
              //this.$notify.success({
              //   title: this.$t('h.common.tip'),
              //   message: this.$t('h.common.tipChangePasswordSuccess'),
              // })
              this.$router.push('/account/login')
            } else {
              let result=translateResMessage(res.message)
              this.errorMsg = this.$t(result)
              //this.$notify.error({
              //   title: this.$t('h.common.tip'),
              //   message: this.errorMsg,
              // })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';

.mainBoxForm {
  @include background_color("background_color");
  @include font_color("text-color");
}

>>> .changePasswordBox {
  width: 600px;
  height: 555px;
  align-items: center;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .12);
  border-radius: 15px;

  position: relative;
  margin: 0 auto;
  margin-top: 10%;


}


>>>  .changePasswordFormBox {
  width: 330px;
  margin: 0 auto;

  .cardBoxTitle {
    font-size: 26px;
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .subBtn {
    width: 100%;
  }


  .formBoxFooter {
    font-size: 10px;
    margin-top: 30px;
  }

  .el-input__inner {
    height: 25px;
    border-radius: 0px;
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    border-bottom-width: 1px;
    padding: 0; /* 确保 padding 设置为 0 */
    margin: 0; /* 确保 margin 设置为 0 */
    @include font_color('text-color');
    @include background_color("background_color");
  }

  .el-input__inner::placeholder {
    @include font_color("elInputPlaceholderColor");
  }
  .el-input__inner:focus {
    border-bottom-width: 2px;
    @include border_color("elInputBorderFocusColor");
  }

  .input_icon {
    cursor: pointer;
    width: 24px;
    padding-top: 8px;
    padding-right: 6px;
  }

}

</style>



// WEBPACK FOOTER //
// src/views/account/changePassword.vue